import { useState } from 'react'
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  CardActions,
} from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { base_url } from 'env'
import PageAppBar from 'components/PageAppBar'
import { toast } from 'react-hot-toast'

export default function UserPasswordEditPage() {
  const { login } = useParams<{ login: string }>()
  const navigate = useNavigate()

  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!newPassword || !confirmPassword) {
      toast.error('Veuillez remplir tous les champs.')
      return
    }

    if (newPassword !== confirmPassword) {
      toast.error('Les mots de passe ne correspondent pas.')
      return
    }

    if (newPassword.length < 8) {
      toast.error(
        'Le nouveau mot de passe doit contenir au moins 8 caractères.'
      )
      return
    }

    setIsSubmitting(true)
    try {
      // Corrected: The API to update user details, including password, is PUT /user/{login}
      await axios.put(`${base_url}/user/${login}`, {
        password: newPassword, // Corrected: The payload should contain the new password in the 'password' field
      })
      toast.success('Mot de passe mis à jour avec succès !')
      navigate(`/user/${login}`) // Corrected: Navigate back to the user preview page on success
    } catch (err: any) {
      // The global error handler will now display the toast notification.
      console.error(err)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <PageAppBar pageName={`Changer le mot de passe pour ${login}`}>
      <Box
        sx={{
          p: 3,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
        }}
      >
        <Card sx={{ width: '100%', maxWidth: '600px' }}>
          <Box component="form" onSubmit={handleSubmit}>
            <CardContent
              sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
            >
              <Typography variant="h5" component="h2">
                Nouveau mot de passe
              </Typography>

              {/* Removed unnecessary success/error alerts, as react-hot-toast now handles them */}

              <TextField
                fullWidth
                required
                type="password"
                label="Nouveau mot de passe"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                helperText="Doit contenir au moins 8 caractères."
              />
              <TextField
                fullWidth
                required
                type="password"
                label="Confirmer le nouveau mot de passe"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </CardContent>
            <CardActions sx={{ p: 2, justifyContent: 'space-between' }}>
              <Button
                variant="outlined"
                onClick={() => navigate(`/user/${login}`)}
              >
                Annuler
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Sauvegarder'
                )}
              </Button>
            </CardActions>
          </Box>
        </Card>
      </Box>
    </PageAppBar>
  )
}
